/* 搭配款式（Frequently bought together）— 归属 A。
   数据由 sections/jn-product-bundle-data.liquid 经 Section Rendering API 提供。
   价格全部是真实价格：本店没有捆绑折扣 app，不画划线价。 */
(function () {
  var CUR = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';

  function money(cents) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency',
        currency: CUR,
        minimumFractionDigits: cents % 100 === 0 ? 0 : 2,
      }).format(cents / 100);
    } catch (e) {
      return '$' + (cents / 100).toFixed(2);
    }
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* 0908 修复(R01)①：本品那一行原来永远读 snippets/jn-product-bundle.liquid 输出的
     data-this-* —— 那是**页面初始变体**。客户在 Fiore 上选了 48"/Bronze，This item 行、
     Total、以及加购真正送出去的 id 全都还停在 39"/Silver（实测入车的是 $5,600 那个变体）。
     现在 data-this-* 只当首屏初值，真值每次都从购买盒里读：
       id  ← <input name="id" data-variant-id>（product.liquid 的 apply() 会改它）
       其余 ← <script data-variants> 里那条变体的 price / price_html / options / available
     变体 JSON 拿不到时（理论上不会）退回 data-this-*，行为跟改之前一样。 */
  function variantsJson(root) {
    var host = root.closest ? root.closest('jn-product') : null;
    var el = (host || document).querySelector('[data-variants]');
    if (!el) return [];
    if (el._jnParsed) return el._jnParsed;
    try {
      el._jnParsed = JSON.parse(el.textContent) || [];
    } catch (e) {
      el._jnParsed = [];
    }
    return el._jnParsed;
  }

  function selfItem(root) {
    var d = root.dataset;
    var fallback = {
      id: d.thisId,
      title: d.thisTitle,
      variant: '',
      price: parseInt(d.thisPrice, 10) || 0,
      priceHtml: d.thisPriceHtml,
      img: d.thisImg,
      available: true,
      self: true,
    };
    var input = document.querySelector('[data-variant-id]') || document.querySelector('form[data-product-form] [name="id"]');
    if (!input || !input.value) return fallback;
    var list = variantsJson(root);
    for (var i = 0; i < list.length; i++) {
      if (String(list[i].id) === String(input.value)) {
        var v = list[i];
        return {
          id: String(v.id),
          title: d.thisTitle,
          /* 选中的规格写在本品行下方，客户一眼看得出加的是哪一个（原来这里永远空着） */
          variant: v.label || (v.options ? v.options.join(' · ') : ''),
          price: v.price || 0,
          priceHtml: v.price_html || d.thisPriceHtml,
          img: d.thisImg,
          available: v.available !== false,
          self: true,
        };
      }
    }
    return fallback;
  }

  function render(root, items) {
    var d = root.dataset;
    var all = [selfItem(root)].concat(items);

    var html = '<p class="jn-eyebrow jn-bundle__h">' + esc(d.title) + '</p><ul class="jn-bundle__list" role="list">';
    all.forEach(function (it, i) {
      var id = 'jn-bundle-' + i + '-' + Math.abs(parseInt(it.id, 10) || i);
      html +=
        '<li class="jn-bundle__row"' + (it.self ? ' data-bundle-self' : '') + '>' +
        rowInner(root, it, id) +
        '</li>';
    });
    html +=
      '</ul>' +
      /* 0908 修复(R01)③：加购失败原来只把按钮文案跳回，一个字的说明都没有
         （售罄 422 / 限流 429 都是静默）。这一行专门放错误文案。 */
      '<p class="jn-bundle__msg jn-small" data-bundle-msg role="status" aria-live="polite" hidden></p>' +
      '<div class="jn-bundle__foot">' +
      '<span class="jn-bundle__total"><span class="jn-small">' + esc(d.tTotal) + '</span> <b class="jn-price" data-bundle-total></b></span>' +
      '<button type="button" class="jn-btn jn-bundle__add" data-bundle-add><span data-bundle-add-label>' + esc(d.tAdd) + '</span></button>' +
      '</div>';

    root.innerHTML = html;
    root.hidden = false;
    root._items = all;
    updateTotal(root);
  }

  /* 一行的内部结构。本品行要跟着变体重画，所以单独拆出来（syncSelf 复用同一份模板）。 */
  function rowInner(root, it, id) {
    var soldOut = it.available === false;
    var note = it.self
      ? esc(root.dataset.tThisItem || 'This item') + (soldOut ? ' — sold out' : '') + (it.variant ? ' · ' + esc(it.variant) : '')
      : it.variant && it.variant !== 'Default Title'
        ? esc(it.variant)
        : '';
    return (
      /* 0908 修复(R12)：售罄的本品不再默认勾上 —— 原来它照样算进 Total（实测 trufa
         Total $1,290 含一件根本买不到的货），点加购整批 422 静默失败。 */
      '<input class="jn-bundle__check" type="checkbox" id="' + id + '" value="' + esc(it.id) + '"' +
      (soldOut ? '' : ' checked') +
      (it.self || soldOut ? ' disabled' : '') +
      '>' +
      '<label class="jn-bundle__label" for="' + id + '">' +
      (it.img ? '<img class="jn-bundle__img" src="' + esc(it.img) + '" alt="" width="56" height="56" loading="lazy">' : '<span class="jn-bundle__img jn-ph"></span>') +
      '<span class="jn-bundle__meta">' +
      '<span class="jn-bundle__title">' + esc(it.title) + '</span>' +
      (note ? '<span class="jn-bundle__note jn-small">' + note + '</span>' : '') +
      '</span>' +
      '<span class="jn-bundle__price jn-price">' + esc(it.priceHtml) + '</span>' +
      '</label>'
    );
  }

  /* 0908 修复(R01)①：变体一变就重画本品行并重算 Total。
     触发源两条：product.liquid 的 apply() 广播的 jn:variant，以及色板 aria-pressed 的
     MutationObserver 兜底（跟 sections/jn-product-dimensions.liquid 用的是同一招）。 */
  function syncSelf(root) {
    if (!root._items || !root._items.length) return;
    var li = root.querySelector('[data-bundle-self]');
    if (!li) return;
    var it = selfItem(root);
    var prev = root._items[0];
    if (prev && String(prev.id) === String(it.id) && prev.available === it.available) return;
    root._items[0] = it;
    li.innerHTML = rowInner(root, it, 'jn-bundle-0-' + Math.abs(parseInt(it.id, 10) || 0));
    updateTotal(root);
  }

  function updateTotal(root) {
    var boxes = root.querySelectorAll('.jn-bundle__check');
    var total = 0;
    var n = 0;
    boxes.forEach(function (b, i) {
      if (b.checked) {
        total += root._items[i].price;
        n++;
      }
    });
    var el = root.querySelector('[data-bundle-total]');
    if (el) el.textContent = money(total);
    var btn = root.querySelector('[data-bundle-add]');
    if (btn) btn.disabled = n === 0;
  }

  function showMsg(root, text) {
    var el = root.querySelector('[data-bundle-msg]');
    if (!el) return;
    el.textContent = text || '';
    el.hidden = !text;
  }

  function addSelected(root) {
    var btn = root.querySelector('[data-bundle-add]');
    var label = root.querySelector('[data-bundle-add-label]');
    var boxes = [].slice.call(root.querySelectorAll('.jn-bundle__check'));
    var picks = boxes.filter(function (b) { return b.checked; }).map(function (b) { return b.value; });
    if (!picks.length) return;

    var idle = label.textContent;
    btn.disabled = true;
    label.textContent = root.dataset.tAdding;
    showMsg(root, '');

    var items = picks.map(function (id) { return { id: id, quantity: 1 }; });
    var done = function () {
      label.textContent = root.dataset.tAdded;
      setTimeout(function () { label.textContent = idle; btn.disabled = false; }, 1600);
    };
    var fail = function (err) {
      label.textContent = idle;
      btn.disabled = false;
      /* 0908 修复(R01)③：失败要说人话。cart.js 把 Shopify 的 description 带在 err.message 里
         （售罄是 "You can only add N to the cart"、限流是 429），拿不到就给一句通用的。 */
      var m = (err && err.message) || '';
      showMsg(root, m || 'We could not add these right now. Please try again.');
    };

    /* 0908 修复(R01)②：改调 window.JN.cart.add —— 原来这里自建 fetch('/cart/add.js') 后
       只 emit('cart:open')，而 cart.js 的 cart:open 只负责 open()、不刷新 sections，
       结果角标已经变 3、抽屉却写 "Your cart is empty"，关掉重开还是空（回归表 #6）。
       cart.add 自带 Section Rendering 刷新 + 打开抽屉 + 广播 cart:updated。 */
    if (window.JN && window.JN.cart && window.JN.cart.add) {
      window.JN.cart.add(items).then(done, fail);
      return;
    }

    /* cart.js 没加载出来时的兜底：老路径 + 手动广播，至少不把加购功能整个丢掉 */
    fetch(root.dataset.addUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items }),
    })
      .then(function (r) { return r.ok ? r.json() : Promise.reject(new Error(String(r.status))); })
      .then(function () { return fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart.js' : '/cart.js'); })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (window.JN && window.JN.emit) {
          window.JN.emit('cart:updated', { cart: cart });
          window.JN.emit('cart:open', {});
        }
        done();
      })
      .catch(fail);
  }

  function load(root) {
    if (root.dataset.state) return;
    root.dataset.state = 'loading';
    var tryUrl = function (url, next) {
      return fetch(url)
        .then(function (r) { return r.ok ? r.text() : Promise.reject(new Error(String(r.status))); })
        .then(function (t) {
          var doc = new DOMParser().parseFromString(t, 'text/html');
          /* 数据以 data-* 属性给过来，不是 JSON —— Liquid 手拼 JSON 遇到带查询参数的
             商品 URL 会丢逗号，整块解析失败（2026-09-07 踩过） */
          var items = [].slice.call(doc.querySelectorAll('[data-bundle-data] > li')).map(function (li) {
            return {
              id: li.dataset.id,
              title: li.dataset.title,
              variant: li.dataset.variant,
              price: parseInt(li.dataset.price, 10) || 0,
              priceHtml: li.dataset.priceHtml,
              img: li.dataset.img,
            };
          }).filter(function (it) { return it.id && String(it.id) !== String(root.dataset.thisId); });
          if (!items.length && next) return tryUrl(next, null);
          return items;
        });
    };
    tryUrl(root.dataset.url, root.dataset.fallbackUrl)
      .then(function (items) {
        if (!items.length) { root.dataset.state = 'empty'; return; }
        render(root, items.slice(0, 2));
        root.dataset.state = 'loaded';
      })
      .catch(function () { root.dataset.state = 'error'; });
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-bundle]').forEach(function (root) {
      if (root.dataset.state) return;
      root.addEventListener('change', function (e) {
        if (e.target.classList.contains('jn-bundle__check')) updateTotal(root);
      });
      root.addEventListener('click', function (e) {
        if (e.target.closest('[data-bundle-add]')) addSelected(root);
      });
      /* 0908 修复(R01)①：变体切换后重画本品行。两条来源都接：
         product.liquid apply() 的 jn:variant 广播（准），色板 aria-pressed 的
         MutationObserver（兜底，万一 product.liquid 的 JS 版本比这支旧）。 */
      var resync = function () {
        if (root._raf) return;
        root._raf = window.requestAnimationFrame(function () {
          root._raf = 0;
          syncSelf(root);
        });
      };
      document.addEventListener('jn:variant', resync);
      if (window.MutationObserver) {
        var mo = new MutationObserver(resync);
        mo.observe(document.body, { subtree: true, attributes: true, attributeFilter: ['aria-pressed'] });
      }
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          if (entries.some(function (x) { return x.isIntersecting; })) { io.disconnect(); load(root); }
        }, { rootMargin: '0px 0px 500px 0px' });
        io.observe(root);
      } else {
        load(root);
      }
    });
  }

  init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
